import React from "react";
import { Anchor } from "@mantine/core";
import {
  assetDisplayName,
  fileTypeIcon,
  isImageContentType,
} from "./chatFilePreview";
import classes from "./ChatTray.module.css";

export default function ChatMessageAttachment({ asset, mine }) {
  const url = asset?.filename_url;
  const name = assetDisplayName(asset);
  const contentType = asset?.content_type;
  const isImage = isImageContentType(contentType);

  if (!url) {
    return (
      <div className={classes.attachmentRow}>
        {fileTypeIcon(contentType)}
        <span className={classes.attachmentName}>{name}</span>
      </div>
    );
  }

  if (isImage) {
    return (
      <a
        className={classes.attachmentThumbLink}
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <img
          className={classes.attachmentThumb}
          src={url}
          alt={name}
          loading="lazy"
        />
      </a>
    );
  }

  return (
    <Anchor
      className={classes.attachmentRow}
      href={url}
      target="_blank"
      rel="noreferrer"
      size="sm"
      c={mine ? "white" : "blue"}
      underline="hover"
    >
      {fileTypeIcon(contentType)}
      <span className={classes.attachmentName}>{name}</span>
    </Anchor>
  );
}
